






































import { LayoutModule } from "@/store/layout";
import { Component, Vue, Watch } from "vue-property-decorator";
import Definition from "@/models/definition";
import DefinitionsAPI from "@/services/definitions";
import TableActions from "@/components/TableActions.vue";
import { Meta } from "@/models/general";
import { get } from "lodash";

@Component({
  components: { TableActions },
})
export default class Definitions extends Vue {
  headers = [
    {
      text: this.$t("definitions.model.name"),
      value: "name",
    },
    {
      text: this.$t("definitions.model.value"),
      value: "value",
    },
    {
      text: "",
      value: "actions",
    },
  ];

  definitions: Definition[] = [];
  meta: Meta = new Meta();
  pagination = {};
  loading = true;

  created(): void {
    this.getRecords();
  }

  async getRecords(): Promise<void> {
    this.loading = true;
    try {
      const r = await DefinitionsAPI.list(
        this.meta.pagination.current,
        this.meta.pagination.size
      );
      this.definitions = r.data;
      this.meta = new Meta(r.meta);
    } catch (e) {
      console.log(e);
    }

    this.loading = false;
  }

  editDefinition(id: string): void {
    this.$router.push({ name: "editDefinition", params: { id } });
  }

  deleteDefinition(id: string): void {
    LayoutModule.setDialogTitle("definitions.delete");
    LayoutModule.setDialogType("error");
    LayoutModule.setDialogCallback(
      async (): Promise<null> => {
        LayoutModule.showLoader();
        await DefinitionsAPI.delete(id);
        await this.getRecords();
        LayoutModule.hideLoader();
        return null;
      }
    );
    LayoutModule.showDialog();
  }

  @Watch("pagination", { deep: true })
  handlePagination(): void {
    this.meta.pagination.current = get(this.pagination, "page");
    this.meta.pagination.size = get(this.pagination, "itemsPerPage");

    this.getRecords();
  }
}
